module.exports = __webpack_public_path__ + "baf4730039b9f6ef5e3c7809342662f1.fbx";